export default __webpack_public_path__ + "static/media/codeschool.647aa16a.svg";